export default {"src":"/_next/static/media/twitter-newlogo.d168cafd.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};